import { Separator } from '../components/Separator';
import type { CustomOptionProps } from '../types';

export const getSeparator = (key: string): CustomOptionProps => ({ key, custom: () => <Separator key={key} /> });
